import React from 'react'
import { string } from 'prop-types'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import GenericDropdown from '../../generic-dropdown.jsx'
import { FormattedMessage } from 'react-intl'

const CrmDocumentTypeSelect = props => {
  const variables = {}
  const qlq = gql`
    {
      document_types {
        document_type_uid
        name
      }
    }
  `
  return (
    <Query query={qlq} variables={variables}>
      {({ loading, error, data, refetch }) => {
        const options =
          data && data.document_types
            ? data.document_types.map(v => ({
                ...v,
                value: v.document_type_uid
              }))
            : []
        return (
          <GenericDropdown
            {...props}
            options={options}
            placeholder={
              props.placeholder ? (
                props.placeholder
              ) : (
                <FormattedMessage
                  id="crm.ui.dropdown.select_document_type"
                  defaultMessage="Select Document Type"
                />
              )
            }
          />
        )
      }}
    </Query>
  )
}

CrmDocumentTypeSelect.propTypes = {
  placeholder: string
}

export default CrmDocumentTypeSelect
